import { React, useRef } from 'react';
import styled from 'styled-components';

export default function RefundPriceInput(props) {
  const { division, value, setValue } = props;
  const InputRef = useRef();

  function handleClick(e) {

  }

  function handleChange(e) {
    var regex = /[^0-9]/g;				// 숫자가 아닌 문자열을 매칭하는 정규식
    var result = e.target.value.replace(regex, "");	// 원래 문자열에서 숫자가 아닌 모든 문자열을 빈 문자로 변경
    
    if (result === '') setValue(0);
    else setValue(parseInt(result));
  }

  function handleFocus(e) {
  }

  function handleBlur(e) {
  }

  return (
    <TopLevelWrapper>
        <Input
          ref={InputRef}
          value={value}
          onClick={handleClick}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}/>
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>원</Text>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  
  gap: 5px;
`;

const Input = styled.input`
  font-family: NotoSansKR-Regular;
  font-size: 14px;
  
  padding: 0 10px;

  outline: none;
  border: 1px solid #B2B2B2;
  border-radius: 5px;
  color: #000000;

  width: 174px;
  height: 30px;

  ::placeholder {
    color: #777777;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  } 
`;